import { refLoad } from './store';
import { checkStoreStatus } from '@/util/util.jsx';
import { REF_NAME, REF_PATH } from './Const';
import store from '@/store/store';

export function getProductWrapper(id) {
  if (!checkStoreStatus(REF_NAME, REF_PATH, refLoad, 'INF')) {
    return undefined;
  }
  return store
    .getState()
    .getIn(['references', 'complex', REF_PATH])
    .find(ref => ref.get('id') == id);
}
export function getProductTypeWrapper(parentId, id) {
  if (!checkStoreStatus(REF_NAME, REF_PATH, refLoad, 'INF')) {
    return undefined;
  }
  const product = store
    .getState()
    .getIn(['references', 'complex', REF_PATH])
    .find(ref => ref.get('id') == parentId);
  if (product) {
    return product.get('productTypes')
      .find(ref => ref.get('id') == id);
  } return undefined;
}

export function getProductListWrapper() {
  if (!checkStoreStatus(REF_NAME, REF_PATH, refLoad, 'INF')) {
    return undefined;
  }
  return store.getState().getIn(['references', 'complex', REF_PATH]);
}
